import { ArchivePlusOutlineIcon } from './ArchivePlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id C2898E88-9D7F-44D1-A653-539A4B5481EC
 * name archive-plus-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-plus-outline.svg
 * tags
 */
export const BoxAddOutlineIcon = ArchivePlusOutlineIcon;
export default BoxAddOutlineIcon